<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div v-else>
            <v-row>
                <v-col xs="12" sm="12" md="8" lg="10" xl="10" cols="12">
                    <div class="title_page ma-3 mb-0">
                        <h4 class="breadcrumb_title_page">รายละเอียดสินค้า</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                                <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
                <v-col xs="12" sm="12" md="4" lg="2" xl="2" cols="12">
                    <div class="title_page ma-3">
                        <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()"
                            large>ย้อนกลับ</v-btn>
                    </div>
                </v-col>
            </v-row>
            <section class="mt-10">
                <div class="ma-5">
                    <v-card elevation="4" class="pa-3 card_relative">
                        <div class="tag_header_profile d-flex">
                            <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                <div class="logo_timeline mx-auto my-auto">
                                    <img src="@/assets/arin_assets/box.png">
                                </div>
                            </div>
                            <v-card elevation="3" class="card_title ml-n5">
                                <div class="arin-text-color py-1 pl-8 pr-5">ข้อมูลสินค้า</div>
                            </v-card>
                        </div>
                        <v-row class="pa-4">
                            <v-col cols="12" lg="3" md="4" sm="4" xl="3" xs="12">
                                <div>
                                    <img v-if="product.picture" class="preview profile_img" :src="product.picture">
                                    <img v-else class="preview profile_img" :src="img_holder">
                                </div>
                            </v-col>
                            <v-col cols="12" lg="9" md="8" sm="8" xl="9" xs="12">
                                <v-row>
                                    <v-col cols="12">
                                        <div class=" text_title">ชื่อสินค้า : <span class="text_detail"> {{ product.product_name }}
                                            </span></div>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="12">
                                        <div class=" text_title">ชื่อทางการแพทย์ : <span
                                                class="text_detail">{{ product.name_sci }}</span></div>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="12">
                                        <div class=" text_title">จำนวนสินค้าในคลังไม่ควรน้อยกว่า : <span
                                                class="text_detail">{{ product.min }} หน่วย</span></div>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                        <div class=" text_title">รายละเอียด : <span
                                                class="text_detail">{{ product.detail }}</span></div>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <td>หน่วยนับ</td>
                                                <td>บาร์โค๊ด</td>
                                                <td>ราคาขายปลีก</td>
                                                <td>ราคาสมาชิก</td>
                                                <td>ราคาพนักงาน</td>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(detail, index) in product.product_list" :key="index">
                                                <td class="hidden_line">{{ detail.unit_name }}</td>
                                                <td class="hidden_line">{{ detail.product_barcode }}</td>
                                                <td class="hidden_line">{{ detail.price_standard == null ? '-' :
                                                    detail.price_standard }}</td>
                                                <td class="hidden_line">{{ detail.price_register == null ? '-' :
                                                    detail.price_register }}</td>
                                                <td class="hidden_line">{{ detail.price_employee == null ? '-' :
                                                    detail.price_employee }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>
            </section>

            <section class="mt-10">
                <div class="ma-5">
                    <v-card elevation="4" class="pa-3 card_relative">
                        <div class="tag_header_profile d-flex">
                            <div class="grad-dark-brown-arin-bg pa-2 rounded-pill"
                                style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                                <div class="logo_timeline mx-auto my-auto">
                                    <img src="@/assets/arin_assets/box.png">
                                </div>
                            </div>
                            <v-card elevation="3" class="card_title ml-n5">
                                <div v-if="$route.query.status == 0" class="arin-text-color py-1 pl-8 pr-5">
                                    ประวัติการนำสินค้าเข้าคลัง</div>
                                <div v-else class="arin-text-color py-1 pl-8 pr-5">ประวัติการนำสินค้าออกคลัง</div>
                            </v-card>
                        </div>

                        <v-row>
                            <v-col xs="12" sm="12" md="12" lg="12" xl="12" cols="12">
                                <v-simple-table>
                                    <template v-slot:default>
                                        <thead>
                                            <tr>
                                                <th>วันที่นำออก</th>
                                                <th>จำนวน</th>
                                                <th>หน่วยนับ</th>
                                                <th>ราคาต่อหน่วย</th>
                                                <th>มูลค่าสินค้าทิ้ง</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="item in product.history_dump_list" :key="item.id">
                                                <td class="hidden_line">{{ item.export_date == null ? '-' :
                                                    item.export_date }}</td>
                                                <td class="hidden_line">{{ item.quantity == null ? '-' : item.quantity }}</td>
                                                <td class="hidden_line">{{ item.unit_name == null ? '-' : item.unit_name }}
                                                </td>
                                                <td class="hidden_line">{{ item.cost == null ? '-' : item.cost }}</td>
                                                <td class="hidden_line">{{ item.total == null ? '-' :
                                                    item.total }}</td>
                                            </tr>
                                        </tbody>
                                    </template>
                                </v-simple-table>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import { HTTP_ARIN } from "@/axios_arin";
import img_holder from "@/assets/pharmacy.png";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Detail_customer_point",
    data() {
        return {
            loading_page: false,
            img_holder: img_holder,
            product: [],
            sub_menu: [
                {
                    text: 'คลังสินค้า',
                    disabled: false,
                },
                {
                    text: 'ระบบ POS',
                    disabled: false,
                },
                {
                    text: 'คลังสินค้า',
                    disabled: false,
                },
                {
                    text: 'รายละเอียดสินค้า',
                    disabled: false,
                    href: '#',
                },
            ],

        }
    }, methods: {
        link(link) {
            window.location.href = link;
        },
       async getDetailList() {
            this.loading_page = true;
            this.product = []
            const config = { headers: { "Authorization": `Bearer ${this.$store.state.store_arin.access_token}` } }
          await HTTP_ARIN.post('/pos/storage/product/dump/detail', {product_id: this.$route.query.id, unit_id: this.$route.query.unit_id}, config).then((res) => {
                if (res.data.successful === true) {
                    this.product = res.data.data;
                    this.loading_page = false;
                }
            })
        },
    },
    mounted() {
            this.getDetailList()
    },
}
</script>

<style scoped>
.card_relative {
    position: relative;
    border-radius: 15px;
}

.profile_detail {
    display: grid;
    grid-template-columns: 30% 70%;
}

.header_half {
    display: grid;
    grid-template-columns: 50% 50%;
}

.logo_timeline {
    width: 25px;
    height: 25px;
    padding: 0px;
}

.logo_timeline>img {
    max-width: 25px;
}

.tag_header_profile {
    position: absolute;
    top: -30px;
    left: -15px;
}

.arin-text-color {
    color: #84611F;
    font-weight: bold;
    font-size: 16px;
}

.arin-text-color-two {
    color: #616A6B;
    font-weight: bold;
    font-size: 16px;
}

.card_title {
    margin-top: 1px;
    margin-bottom: 1px;
    border-radius: 10px;
    border: 1px solid #D6BFAF;
}

.preview {
    border-radius: 10px;
}

.preview.profile_img {
    max-width: 172px;
    border-radius: 30px;
}

.employee_box {
    border-radius: 10px;
    border: 1px solid #D6BFAF;
    width: auto;
}

.sub_title {
    font-size: 16px;
}

.image_title {
    font-weight: 500;
    font-size: 16px;
}

.picture_details {
    display: grid;
    grid-template-columns: 40% 60%;
}

.mobile_btn {
    width: 40%;
}

.grid_half {
    display: grid;
    grid-template-columns: 50% 50%;
}

.grid_four_ck {
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
}

.text_title {
    color: #909090;
    font-weight: bold;
    font-size: 16px;
}

.text_detail {
    color: #616A6B;
    font-weight: bold;
    font-size: 16px;
}</style>
